import React, { Component } from 'react';
import QrReader from 'react-qr-reader';
import QRQinectAPI from '../QRQinectAPI';

export default class ActivateQRCode extends Component {
    constructor(props) {
        super(props)
        this.state = {
            delay: 500,
            result: 'Please scan a QR code to continue',
            guid: '',
            showGo: false,
            showScanner: true,
            cardName: "",
            error: "",
            status: ""
        }
        this.handleScan = this.handleScan.bind(this);
        this.scanAnother = this.scanAnother.bind(this);
        this.scanpending = false;
    }
    handleScan(data) {
        if (data) {
            if (this.scanpending) {
                return;
            }
            this.scanpending = true;
            let showGo = false;
            let error = '';
            let guid = '';
            if (data.indexOf("qr.saymore.net") !== -1) {
                // get the GUID
                let lastSlash = data.lastIndexOf("/");
                if (lastSlash !== -1) {
                    guid = data.substr(lastSlash + 1);
                }
                QRQinectAPI.getQRCode(guid)
                .then ((response) => {
                    if (response.data.ID !== 0 && response.data.Active === false) {
                        // exists and inactive
                        // good to activate
                        showGo = true;
                    } else {
                        // show a message stating that the code is invalid or already active.
                        error = "Invalid QRCode";
                        if (response.data.Active) {
                            error = "QRCode is already active";
                        }
                    }
                })
                .catch((error) => {
                    // didn't work, oh well.
                })
                .finally (() => {
                    this.scanpending = false;
                    this.setState({
                        guid: guid,
                        error: error,
                        result: guid,
                        showGo: showGo
                    });
                })
            } else {
                this.scanpending = false;
                this.setState({
                    guid: '',
                    error: error,
                    result: data,
                    showGo: showGo
                });
            }
        }
    }
    handleError(err) {
        console.log(err);
    }
    handleIDChange(event) {
        this.setState({guid: event.target.value, error: '', status: ''});
    }
    handleNameChange(event) {
        this.setState({cardName: event.target.value});
    }
    activateQRCode = () => {
        QRQinectAPI.activateQRCode(this.state.guid, this.state.cardName)
        .then((response) => {
            // show success
            this.setState({status: "QRCode Activated", error: ""});
        })
        .catch((error) => {
            console.log(error.response);
            this.setState({status: "", error: error.response.data});
        })
    }
    scanAnother() {
        this.setState({
            showGo: false,
            result: 'Please scan a QR code to continue',
            error: '',
            status: ''
        });
    }
    renderGoButton() {
        if (this.state.showGo) {
            return (
                <React.Fragment>
                    <p>{this.state.guid}</p>
                    <label htmlFor="cardName1">Card Name</label><input id="cardName1" type="text" value={this.state.cardName} onChange={event => this.handleNameChange(event)}></input>
                    {this.renderStatus()}
                    <a className="button" style={{ paddingTop: '24px', paddingBottom: '24px' }} onClick={this.activateQRCode}>ACTIVATE</a>
                    <a className="button" style={{ paddingTop: '24px', paddingBottom: '24px', backgroundColor: '#666', cursor: 'pointer' }} onClick={this.scanAnother}>SCAN ANOTHER CODE</a>
                </React.Fragment>
            );
        }
    }
    renderStatus() {
        if (this.state.error !== "") {
            return (
                <React.Fragment>
                    <div style={{textAlign: 'center', fontSize: "larger", color: "red"}}>{this.state.error}</div>
                </React.Fragment>
            );
        } else if (this.state.status !== '') {
            return (
                <React.Fragment>
                    <div style={{textAlign: 'center', fontSize: "larger", color: "green"}}>{this.state.status}</div>
                </React.Fragment>
            );
        }
        return null;
    }
    renderReader() {
        if (this.state.showGo) {
            return null;
        } else if (this.state.showScanner) {
            return (
                <React.Fragment>
                    <div style={{ textAlign: 'center' }}>
                        <p>Please place your QR code within the viewer to begin.</p>
                        <div>Having trouble scanning? Try moving your device closer to/farther from the code.</div>
                    </div>
                    <QrReader
                        delay={this.state.delay}
                        onError={this.handleError}
                        onScan={this.handleScan}
                        style={{ width: '100%' }}
                    />
                    <p>{this.state.result}</p>
                    {this.renderStatus()}
                    <div style={{ textAlign: 'center' }}>
                        <div className="secondaryColor" style={{cursor: 'pointer'}} onClick={() => {this.setState({showScanner: false})}}>
                            <span className="fa-stack" style={{position: 'relative'}}>
                            <i className="fa fa-camera fa-stack-1x" style={{position: 'absolute', fontSize: 'small'}}></i>
                            <i className="fa fa-ban fa-stack-2x " ></i>
                            </span> <span style={{textDecoration: 'underline'}}>Don't Have a Camera?</span>
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return (
                <div>
                    <label htmlFor="enterID">QRCode ID</label>
                    <input id="enterID" type="text" value={this.state.guid} onChange={event => this.handleIDChange(event)}></input>
                    <label htmlFor="cardName2">Card Name</label><input id="cardName2" type="text" value={this.state.cardName} onChange={event => this.handleNameChange(event)}></input>
                    {this.renderStatus()}
                    <a className="button" style={{ paddingTop: '24px', paddingBottom: '24px' }} onClick={this.activateQRCode}>ACTIVATE</a>
                    <div className="secondaryColor" style={{cursor: 'pointer', textAlign: 'center'}} onClick={() => {this.setState({showScanner: true})}}>
                        <span className="fa-stack" style={{position: 'relative'}}>
                            <i className="fa fa-camera fa-stack-1x" style={{position: 'absolute'}}></i>
                            <i className="fa fa-stack-2x " ></i>
                        </span> <span style={{textDecoration: 'underline'}}>Use Camera</span>
                    </div>
                </div>
            );
        }
    }
    render() {
        return (
            <div>
                <div className="login_register">
                    <div className="container">
                        <div className="entry">
                            <div className="head">
                                <div className="logoImage"></div>
                                {this.renderGoButton()}
                                {this.renderReader()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/ActivateQRCode.js